<template>
  <v-form v-model="valid">
    <slot></slot>
    <v-row>
      <v-col cols="12">
        <v-select
          name="addressType"
          label="Address type"
          :value="value.type"
          @input="onInput('type', $event)"
          :items="addressTypeOptions"
          required
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-for="(addressLine, i) of value.addressLines"
          :key="`line_${i}`"
          :label="`Address line ${i + 1}`"
          :name="`addressLine${i + 1}`"
          :autocomplete="`address-line${i + 1}`"
          :value="value.addressLines[i]"
          @input="onInput(`addressLines[${i}]`, $event)"
        >
          <template v-slot:append v-if="i === value.addressLines.length - 1">
            <v-btn
              depressed
              tile
              class="ma-0"
              @click="addAddressLine"
              :disabled="value.addressLines.length >= 8"
            >
              <v-icon>
                add
              </v-icon>
              Add line
            </v-btn>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          label="Locality name"
          name="city"
          autocomplete="locality"
          :value="value.localityName"
          @input="onInput('localityName', $event)"
          :rules="localityNameRules"
          required
        />
      </v-col>
      <v-col cols="6">
        <v-select
          v-if="value.country === 'Australia'"
          name="state"
          label="State / Territory"
          autocomplete="region"
          :value="value.state"
          @input="onInput('state', $event)"
          :items="ausStates"
          :rules="stateRules"
          required
        />
        <v-text-field
          v-else
          name="state"
          label="State / Province"
          autocomplete="region"
          :value="value.state"
          @input="onInput('state', $event)"
          :rules="stateRules"
          required
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          label="Post code"
          name="postal"
          autocomplete="postal-code"
          :value="value.postcode"
          @input="onInput('postcode', $event)"
          :rules="postcodeRules"
          required
        />
      </v-col>
      <v-col cols="12">
        <country-select
          label="Country"
          name="country"
          :value="value.country"
          @input="onInput('country', $event)"
          :rules="countryRules"
          required
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { tap, cloneDeep, set } from 'lodash'
import { addressTypeOptions } from '../../utilities/index.js'

import CountrySelect from './CountrySelect.vue'

export default {
  components: { CountrySelect },
  props: {
    value: {
      type: Object,
      default: () => ({
        type: null,
        addressLines: [null],
        localityName: null,
        postcode: null,
        state: null,
        country: 'Australia'
      })
    }
  },

  data: () => ({
    valid: false,
    localityNameRules: [
      v => !!v || 'Locality is required'
    ],
    stateRules: [
      v => !!v || 'State is required'
    ],
    postcodeRules: [
      v => !!v || 'Postcode is required'
    ],
    countryRules: [
      v => !!v || 'Country is required'
    ],
    addressTypeOptions,
    ausStates: ['QLD', 'NSW', 'ACT', 'VIC', 'SA', 'WA', 'TAS', 'NT']
  }),

  methods: {
    addAddressLine () {
      this.$emit('input', tap(cloneDeep(this.value), v => v.addressLines.push(null)))
    },
    onInput (key, value) {
      const o = { ...this.value }
      set(o, key, value)
      this.$emit('input', o)
    }
  },

  watch: {
    valid (valid) {
      this.$emit('valid', valid)
    }
  }
}
</script>
